import Vue from "vue"
import auth from '@/mixins/auth'
import mobile from '@/mixins/mobile'

Vue.mixin({
    mixins: [
        auth,
        mobile
    ],
    data() {
        return {
            busyItems: [],
        }
    },
    methods: {
        data_get(object, key) {
            return _.get(object, key)
        },
        isItemBusy(item, action = null) {
            return !!this.busyItems.find(i => (typeof item === 'object' ? i.item == item : i.item === item) && i.action === action);
        },
        addBusyItem(item, action = null) {
            this.busyItems.push({
                item,
                action,
            });
        },
        removeBusyItem(item, action = null) {
            let found = this.busyItems.find(i => (typeof item === 'object' ? i.item == item : i.item === item) && action === action);
            if (found) {
                this.busyItems.splice(this.busyItems.indexOf(found), 1);
            }
        }
    }
});
